import { cleanBotHtml, getOriginalBotMsg, getRelativeLinks } from "./chatbotUtils";

export const handleDownloadResult = (htmlContent, question = "") => {
  let safeQuestion = question
    ? question
      .replace(/[\\/:*?"<>|]/g, "")
      .trim()
      .substring(0, 50)
    : "اجابة_المساعد";
  if (!safeQuestion) safeQuestion = "اجابة_المساعد";
  const now = new Date();
  const dateStr =
    now.getFullYear() +
    "-" +
    String(now.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(now.getDate()).padStart(2, "0") +
    "_" +
    String(now.getHours()).padStart(2, "0") +
    "-" +
    String(now.getMinutes()).padStart(2, "0") +
    "-" +
    String(now.getSeconds()).padStart(2, "0");
  const filename = `${safeQuestion}_${dateStr}.html`;
  const element = document.createElement("a");
  const file = new Blob(
    [
      `
          <!DOCTYPE html>
              <html lang="ar" dir="rtl">
                  <head>
                      <meta charset="utf-8">
                          <title>إجابة مساعد الذكاء الاصطناعي</title>
                          <link rel="preconnect" href="https://fonts.googleapis.com">
                              <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                                  <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Droid+Arabic+Naskh:wght@400;700&display=swap" rel="stylesheet">
                                      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@7.2.0/css/all.min.css">
                                          <style>
                                              body {
                                                  font-family: 'Cairo', sans-serif;
                                              padding: 30px;
                                              background-color: #fdfaf5;
                                              color: #0e2c53;
                                              line-height: 1.8;
                                              }
                                              table {
                                                  width: 100%;
                                              border-collapse: collapse;
                                              margin: 20px 0;
                                              }
                                              th, td {
                                                  padding: 12px 15px;
                                              text-align: right;
                                              border-bottom: 1px solid #ebd9c5;
                                              }
                                              th {
                                                  background-color: #0e2c53;
                                              color: white;
                                              }
                                              tr:nth-child(even) {
                                                  background-color: #fbf6ee;
                                              }
                                          </style>
                                      </head>
                                      <body>
                                          ${htmlContent}
                                      </body>
                                  </html>
                                  `,
    ],
    { type: "text/html" },
  );
  element.href = URL.createObjectURL(file);
  element.download = filename;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export const handleDownloadFullChat = ({
  messages,
  activeSessionId,
  history,
  downloadExplanation = true,
  downloadChat = true,
  downloadQuestions = true,
  downloadRelativeLessons = true,
  downloadSolved = true,
  downloadStudentAnswers = true,
  downloadHints = true,
  FontSize = 18,
  logoBase64 = null,
  downloadFormat = "html",   // "html" | "word" | "pdf"
  user,
  activeQuestions,
  solvedQuestions = {},
  examAnswers = {},
  t,
  currentLessonInfo = null,
  relativeLessons = [],
}) => {
  const userObj = user && user.user;
  const userName = userObj
    ? userObj.Name ||
    `${userObj.FirstName || ""} ${userObj.LastName || ""}`.trim() ||
    "الطالب"
    : "الطالب";
  const activeSession = history.find((h) => h.id === activeSessionId);
  const sessionTitle = activeSession
    ? activeSession.title
    : "محادثة_مساعد_اللغة_العربية";

  const textFinishAndCalculate = t ? t("Pages.Chatbot.FinishAndCalculate") : "تصحيح الإجابات وحساب النتيجة";

  // 1. Extract Lesson Text
  const originalBotMsg = getOriginalBotMsg(messages);
  const lessonHtml = originalBotMsg
    ? cleanBotHtml(originalBotMsg.text)
    : "";

  // 2. Extract title of the lesson or default to sessionTitle
  const extractTitleFromHtml = (html) => {
    if (!html) return "";
    try {
      const docTitleMatch = html.match(/<h[123][^>]*>(.*?)<\/h[123]>/i);
      if (docTitleMatch && docTitleMatch[1]) {
        return docTitleMatch[1].replace(/<[^>]*>/g, "").replace(/[\n\r\t]/g, " ").replace(/\s+/g, " ").trim();
      }
    } catch (e) {
      console.error("Failed to extract title from HTML:", e);
    }
    return "";
  };
  
  const docTitle = (currentLessonInfo && currentLessonInfo.name) || extractTitleFromHtml(lessonHtml) || sessionTitle || "درس اللغة العربية";
  const docLink = (currentLessonInfo && typeof currentLessonInfo.link === "string" && currentLessonInfo.link) ? (currentLessonInfo.link.startsWith("http") ? currentLessonInfo.link : `https://alarabeyya.com${currentLessonInfo.link}`) : "";

  // Styles definitions
  const customStyles = `
      .download-page-header {
          background-color: #0e2c53;
          color: #ffffff;
          padding: 20px 30px;
          border-radius: 12px;
          margin-bottom: 30px;
          border-bottom: 4px solid #8dc63f;
          text-align: right;
      }
      .header-brand {
          font-size: 22px;
          font-weight: 700;
          text-align: center;
          margin-bottom: 10px;
          color: #ffd54f;
      }
      .header-divider {
          height: 1px;
          background: rgba(255, 255, 255, 0.2);
          margin: 10px 0;
      }
      .header-meta-grid {
          margin-top: 15px;
      }
      .meta-item {
          display: inline-block;
          width: 32%;
          vertical-align: top;
          font-size: 13.5px;
      }
      .section-container {
          background: #ffffff;
          border-radius: 16px;
          padding: 30px;
          margin-bottom: 30px;
          box-shadow: 0 4px 15px rgba(14, 44, 83, 0.03);
          border: 1px solid rgba(14, 44, 83, 0.05);
      }
      .section-title {
          color: #0e2c53;
          font-size: 20px;
          font-weight: 700;
          border-bottom: 2px solid #8dc63f;
          padding-bottom: 8px;
          margin-top: 0;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 10px;
      }
      .section-title i {
          color: #8dc63f;
      }
      .chat-messages-list {
          display: flex;
          flex-direction: column;
          gap: 20px;
      }
      .message-item {
          display: flex;
          flex-direction: column;
          max-width: 85%;
          padding: 15px 20px;
          border-radius: 20px;
          position: relative;
          box-shadow: 0 4px 12px rgba(0,0,0,0.02);
          box-sizing: border-box;
      }
      .message-item.user {
          align-self: flex-start;
          margin-left: auto;
          margin-right: 0;
          background-color: #92278f;
          color: #ffffff;
          border-bottom-right-radius: 4px;
      }
      .message-item.bot {
          align-self: flex-end;
          margin-right: auto;
          margin-left: 0;
          background-color: #f8fafc;
          color: #0e2c53;
          border: 1px solid rgba(14, 44, 83, 0.05);
          border-right: 4px solid #8dc63f;
          border-bottom-left-radius: 4px;
      }
      .message-sender {
          font-weight: 700;
          font-size: 13px;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 8px;
      }
      .message-sender.user {
          color: #ffd54f;
      }
      .message-sender.bot {
          color: #8dc63f;
      }
      .message-content {
          font-size: 15px;
      }
      .lesson-content {
          font-size: 16px;
      }
      .question-item {
          border-bottom: 1px dashed rgba(14, 44, 83, 0.1);
          padding: 20px 0;
          page-break-inside: avoid;
          break-inside: avoid;
      }
      .question-item:last-child {
          border-bottom: none;
      }
      .question-name {
          font-weight: 700;
          color: #0e2c53;
          margin-bottom: 15px;
          font-size: 16px;
      }
      .question-options {
          display: flex;
          flex-direction: column;
          gap: 8px;
          page-break-inside: avoid;
          break-inside: avoid;
      }
      .answer-option {
          padding: 10px 15px;
          background: #f8fafc;
          border: 1px solid rgba(14, 44, 83, 0.05);
          border-radius: 8px;
          margin-bottom: 6px;
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14.5px;
      }
      .answer-option.correct {
          border-color: #8dc63f;
          background: rgba(141, 198, 63, 0.05);
          color: #2b5c0f;
      }
      .answer-option.correct-checked {
          border-color: #8dc63f;
          background: rgba(141, 198, 63, 0.15);
          color: #2b5c0f;
          font-weight: bold;
      }
      .answer-option.incorrect-checked {
          border-color: #ef4444;
          background: rgba(239, 68, 68, 0.08);
          color: #991b1b;
      }
      .answer-option.checked {
          border-color: #0e2c53;
          background: rgba(14, 44, 83, 0.05);
          color: #0e2c53;
          font-weight: bold;
      }
      .text-success { color: #8dc63f !important; }
      .text-danger { color: #ef4444 !important; }
      .text-muted { color: #94a3b8 !important; }

      .student-answer-container {
          margin-top: 10px;
          padding: 12px 15px;
          border-radius: 8px;
          font-size: 14px;
      }
      .student-answer-container.correct {
          background: rgba(141, 198, 63, 0.08);
          border: 1px solid #8dc63f;
          color: #2b5c0f;
      }
      .student-answer-container.incorrect {
          background: rgba(239, 68, 68, 0.08);
          border: 1px solid #ef4444;
          color: #991b1b;
      }
      .student-answer-label {
          font-weight: bold;
          margin-bottom: 4px;
          font-size: 12.5px;
      }
      .relative-lessons-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
          gap: 15px;
      }
      .relative-lesson-card {
          background: #f8fafc;
          border: 1px solid rgba(14, 44, 83, 0.05);
          border-radius: 12px;
          padding: 15px;
          display: flex;
          align-items: center;
          gap: 12px;
          color: #0e2c53;
          text-decoration: none;
          font-weight: bold;
      }
      .relative-lesson-card i {
          color: #ffd54f;
      }
      .download-page-footer {
          margin-top: 50px;
          padding: 20px;
          background-color: #f8fafc;
          border-top: 3px solid #8dc63f;
          border-radius: 12px;
          text-align: center;
          font-size: 12px;
          color: #64748b;
      }
      .footer-divider {
          height: 1px;
          background: rgba(14, 44, 83, 0.1);
          margin: 10px 0;
      }
      .footer-info-grid {
          margin-top: 10px;
          margin-bottom: 15px;
      }
      .footer-info-item {
          display: inline-block;
          width: 32%;
          font-size: 13px;
          color: #0e2c53;
          font-weight: bold;
      }
      .footer-copyright {
          margin: 10px 0 0 0;
          font-weight: bold;
          color: #64748b;
      }

      /* Interactive Option & Print Styles */
      .answer-option.interactive:hover {
          background: #f1f5f9;
          border-color: #cbd5e1;
      }
      .answer-option.interactive.selected {
          border-color: #92278f;
          background: rgba(146, 39, 143, 0.04);
          font-weight: bold;
      }
      .answer-option.interactive.selected .select-icon {
          color: #92278f !important;
      }
      .answer-option.interactive.graded-correct {
          border-color: #8dc63f !important;
          background: rgba(141, 198, 63, 0.08) !important;
          color: #2b5c0f !important;
      }
      .answer-option.interactive.graded-correct .select-icon {
          color: #8dc63f !important;
      }
      .answer-option.interactive.graded-incorrect {
          border-color: #ef4444 !important;
          background: rgba(239, 68, 68, 0.08) !important;
          color: #991b1b !important;
      }
      .answer-option.interactive.graded-incorrect .select-icon {
          color: #ef4444 !important;
      }
      .answer-option.interactive.graded-should-be {
          border-color: #8dc63f !important;
          border-style: dashed !important;
          background: rgba(141, 198, 63, 0.02) !important;
      }
      .answer-option.interactive.graded-should-be .select-icon {
          color: #8dc63f !important;
      }
      
      @media print {
          body {
              background-color: #ffffff;
              padding: 0;
          }
          .section-container {
              box-shadow: none;
              border: none;
              padding: 0;
              margin-bottom: 40px;
              page-break-inside: avoid;
          }
          .question-item {
              page-break-inside: avoid;
          }
          .relative-lessons-grid {
              page-break-inside: avoid;
          }
          .download-page-footer {
              page-break-inside: avoid;
          }
          #btn-grade-sheet, #grading-result-container, .btn-show-hint {
              display: none !important;
          }
          .question-hint-box {
              display: block !important;
          }
      }
      
      body::before {
          content: "";
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          opacity: 0.04;
          pointer-events: none;
          z-index: -1000;
          background-image: url('https://alarabeyya.com/assets/images/logo/logo.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: 380px;
          filter: grayscale(100%);
      }
      @media print {
          body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
          }
          body::before {
              content: "";
              position: fixed;
              top: 0; left: 0; right: 0; bottom: 0;
              opacity: 0.04 !important;
              pointer-events: none;
              z-index: -1000;
              background-image: url('https://alarabeyya.com/assets/images/logo/logo.png') !important;
              background-repeat: no-repeat !important;
              background-position: center !important;
              background-size: 380px !important;
              filter: grayscale(100%) !important;
          }
      }
  `;

  // MS Word Specific Styles
  const wordStyles = `
      p.MsoHeader, li.MsoHeader, div.MsoHeader, p.MsoHeader *, li.MsoHeader *, div.MsoHeader * {
          font-family: 'Cairo', sans-serif !important;
          font-size: 10pt;
          direction: rtl;
          text-align: right;
      }
      p.MsoFooter, li.MsoFooter, div.MsoFooter, p.MsoFooter *, li.MsoFooter *, div.MsoFooter * {
          font-family: 'Cairo', sans-serif !important;
          font-size: 10pt;
          direction: rtl;
          text-align: right;
      }
      body {
          font-family: 'Cairo', sans-serif !important;
          padding: 40px 20px;
          color: #0e2c53;
          line-height: 1.8;
          max-width: 900px;
          margin: 0 auto;
          font-size: ${FontSize || 18}px;
          direction: rtl;
          unicode-bidi: embed;
          text-align: right;
      }
      p, div, li, ol, ul, table, tr, td, h1, h2, h3, h4, h5, h6, span, strong, a {
          direction: rtl;
          unicode-bidi: embed;
          text-align: right;
          font-family: 'Cairo', sans-serif !important;
      }
      .download-page-header {
          background-color: #0e2c53;
          color: #ffffff;
          padding: 20px 30px;
          border-radius: 12px;
          margin-bottom: 30px;
          border-bottom: 4px solid #8dc63f;
          text-align: right;
      }
      .header-brand {
          font-size: 22px;
          font-weight: 700;
          text-align: center;
          margin-bottom: 10px;
          color: #ffd54f;
      }
      .header-divider {
          height: 1px;
          background-color: #ffffff;
          margin: 10px 0;
      }
      .section-container {
          background-color: #ffffff;
          padding: 30px;
          margin-bottom: 30px;
          border: 1px solid #ebd9c5;
      }
      .section-title {
          color: #0e2c53;
          font-size: 20px;
          font-weight: 700;
          border-bottom: 2px solid #8dc63f;
          padding-bottom: 8px;
          margin-top: 0;
          margin-bottom: 20px;
      }
      .question-item {
          border-bottom: 1px dashed #ebd9c5;
          padding: 20px 0;
      }
      .question-name {
          font-weight: 700;
          color: #0e2c53;
          margin-bottom: 15px;
          font-size: 16px;
      }
      .answer-option {
          padding: 10px 15px;
          background-color: #f8fafc;
          border: 1px solid #ebd9c5;
          margin-bottom: 6px;
          font-size: 14.5px;
      }
      .answer-option.correct {
          border-color: #8dc63f;
          background-color: #f4f9eb;
          color: #2b5c0f;
      }
      .answer-option.correct-checked {
          border-color: #8dc63f;
          background-color: #e3f2cd;
          color: #2b5c0f;
          font-weight: bold;
      }
      .answer-option.incorrect-checked {
          border-color: #ef4444;
          background-color: #fdeeed;
          color: #991b1b;
      }
      .answer-option.checked {
          border-color: #0e2c53;
          background-color: #f0f3f6;
          color: #0e2c53;
          font-weight: bold;
      }
      .student-answer-container {
          margin-top: 10px;
          padding: 12px 15px;
          font-size: 14px;
      }
      .student-answer-container.correct {
          background-color: #eff8e2;
          border: 1px solid #8dc63f;
          color: #2b5c0f;
      }
      .student-answer-container.incorrect {
          background-color: #fdeeed;
          border: 1px solid #ef4444;
          color: #991b1b;
      }
      .student-answer-label {
          font-weight: bold;
          margin-bottom: 4px;
          font-size: 12.5px;
      }
      .message-item {
          padding: 10px 15px;
          margin-bottom: 15px;
          border-radius: 8px;
      }
      .message-item.user {
          background-color: #92278f;
          color: #ffffff;
      }
      .message-item.bot {
          background-color: #f8fafc;
          border-right: 4px solid #8dc63f;
          border-top: 1px solid #ebd9c5;
          border-bottom: 1px solid #ebd9c5;
          border-left: 1px solid #ebd9c5;
      }
      .relative-lessons-grid {
          margin-top: 15px;
      }
      .relative-lesson-card {
          background-color: #f8fafc;
          border: 1px solid #ebd9c5;
          padding: 15px;
          color: #0e2c53;
          text-decoration: none;
          font-weight: bold;
          margin-bottom: 10px;
          display: block;
      }
  `;

  // Start building the body content
  const logoImgHtml = logoBase64 
    ? `<img src="${logoBase64}" alt="هيّا إلى العربيّة" style="max-height: 55px; display: block; margin: 0 auto 15px; object-fit: contain;" />`
    : `<img src="/assets/images/logo/logo.png" alt="هيّا إلى العربيّة" style="max-height: 55px; display: block; margin: 0 auto 15px; object-fit: contain;" />`;

  const brandHeaderHtml = `
      <div class="download-page-header" style="background-color: #0e2c53; color: #ffffff; padding: 20px 30px; border-radius: 12px; margin-bottom: 30px; border-bottom: 4px solid #8dc63f; text-align: right; direction: rtl;">
          ${logoImgHtml}
          <div class="header-brand" style="font-size: 22px; font-weight: 700; text-align: center; margin-bottom: 10px; color: #ffd54f;">منصة هيّا إلى العربيّة للتعلم الذكي</div>
          <div class="header-divider" style="height: 1px; background: rgba(255, 255, 255, 0.2); margin: 10px 0;"></div>
          <table width="100%" style="margin-top: 15px; border: none; background: transparent;">
              <tr style="border: none; background: transparent;">
                  <td width="33%" style="color: #ffffff; font-size: 13.5px; border: none; padding: 0; text-align: right; font-family: 'Cairo', sans-serif;">
                      <strong>اسم الطالب:</strong> ${userName}
                  </td>
                  <td width="33%" style="color: #ffffff; font-size: 13.5px; border: none; padding: 0; text-align: center; font-family: 'Cairo', sans-serif;">
                      <strong>الموضوع:</strong> 
                      ${docLink ? `<a href="${docLink}" target="_blank" style="color: #ffd54f; text-decoration: underline;">${docTitle}</a>` : docTitle}
                  </td>
                  <td width="33%" style="color: #ffffff; font-size: 13.5px; border: none; padding: 0; text-align: left; font-family: 'Cairo', sans-serif;">
                      <strong>التاريخ:</strong> ${new Date().toLocaleDateString("ar-EG")}
                  </td>
              </tr>
          </table>
      </div>
  `;

  const wordHeaderHtml = `
      <table width="100%" style="width: 100%; border-bottom: 2px solid #8dc63f; padding-bottom: 10px; font-family: 'Cairo', sans-serif !important; direction: rtl; border-collapse: collapse;">
          <tr style="border: none; background: transparent;">
              <td align="right" valign="middle" style="border: none; padding: 0; width: 150px;">
                  <img src="https://alarabeyya.com/assets/images/logo/logo.png" alt="هيّا إلى العربيّة" width="120" height="40" style="width: 120px; height: 40px; display: block;" />
              </td>
              <td align="center" valign="middle" style="border: none; padding: 0; font-size: 16pt; font-weight: bold; color: #0e2c53; font-family: 'Cairo', sans-serif !important;">
                  <span style="font-family: 'Cairo', sans-serif !important;">منصة هيّا إلى العربيّة للتعلم الذكي</span>
              </td>
          </tr>
      </table>
      <table width="100%" style="width: 100%; margin-top: 15px; border: none; background: transparent; font-family: 'Cairo', sans-serif !important; direction: rtl; border-collapse: collapse;">
          <tr style="border: none; background: transparent;">
              <td width="30%" align="right" style="width: 30%; color: #0e2c53; font-size: 11pt; border: none; padding: 5px 15px 5px 0; font-family: 'Cairo', sans-serif !important; text-align: right;">
                  <span style="font-family: 'Cairo', sans-serif !important;"><strong>اسم الطالب:</strong> ${userName}</span>
              </td>
              <td width="40%" align="center" style="width: 40%; color: #0e2c53; font-size: 11pt; border: none; padding: 5px 15px; font-family: 'Cairo', sans-serif !important; text-align: center;">
                  <span style="font-family: 'Cairo', sans-serif !important;"><strong>الموضوع:</strong> ${docTitle}</span>
              </td>
              <td width="30%" align="left" style="width: 30%; color: #0e2c53; font-size: 11pt; border: none; padding: 5px 0 5px 15px; font-family: 'Cairo', sans-serif !important; text-align: left;">
                  <span style="font-family: 'Cairo', sans-serif !important;"><strong>التاريخ:</strong> ${new Date().toLocaleDateString("ar-EG")}</span>
              </td>
          </tr>
      </table>
  `;

  const wordFooterHtml = `
      <table width="100%" style="width: 100%; border-top: 2px solid #8dc63f; padding-top: 8px; font-family: 'Cairo', sans-serif !important; direction: rtl; border-collapse: collapse; margin-top: 15px;">
          <tr style="border: none; background: transparent;">
              <td width="50%" align="right" style="width: 50%; color: #92278f; font-size: 9.5pt; border: none; padding: 4px 0; font-family: 'Cairo', sans-serif !important; font-weight: bold; text-align: right; direction: rtl;">
                  <span style="font-family: 'Cairo', sans-serif !important;">صفحة <span style="mso-field-code: PAGE"></span> من <span style="mso-field-code: NUMPAGES"></span></span>
              </td>
              <td width="50%" align="left" style="width: 50%; color: #0e2c53; font-size: 9pt; border: none; padding: 4px 0; font-family: 'Cairo', sans-serif !important; font-weight: bold; text-align: left; direction: rtl;">
                  <span style="font-family: 'Cairo', sans-serif !important;">الدعم والاتصال: support@alarabeyya.com | +972-508-680-705</span>
              </td>
          </tr>
          <tr style="border: none; background: transparent;">
              <td colspan="2" align="center" style="color: #64748b; font-size: 8.5pt; border: none; padding: 8px 0 0 0; font-family: 'Cairo', sans-serif !important; font-weight: bold; text-align: center;">
                  <span style="font-family: 'Cairo', sans-serif !important;">جميع الحقوق القانونية وحقوق الملكية الفكرية محفوظة لـموقع هيّا إلى العربيّة © ${new Date().getFullYear()}</span>
              </td>
          </tr>
      </table>
  `;

  let htmlDocBody = "";
  if (downloadFormat !== "word") {
    htmlDocBody += brandHeaderHtml;
  }

  // A. Render Lesson Text (Explanation) - FIRST
  if (downloadExplanation && lessonHtml) {
    htmlDocBody += `
      <div class="section-container" style="background-color: #ffffff; border: 1px solid #ebd9c5; padding: 30px; margin-bottom: 30px; border-radius: 16px;">
          <h2 class="section-title">
              <i class="fa-solid fa-book-open"></i>
              <span>شرح الدرس</span>
          </h2>
          <div class="lesson-content">
              ${lessonHtml}
          </div>
      </div>
    `;
  }

  // B. Render Questions if downloadQuestions is enabled - SECOND
  if (downloadQuestions && activeQuestions && activeQuestions.length > 0) {
    htmlDocBody += `
      <div class="section-container" style="background-color: #ffffff; border: 1px solid #ebd9c5; padding: 30px; margin-bottom: 30px; border-radius: 16px;">
          <h2 class="section-title">
              <i class="fa-solid fa-graduation-cap"></i>
              <span>الأسئلة والتمارين التفاعلية</span>
          </h2>
          <div class="questions-list">
    `;
    activeQuestions.forEach((q, idx) => {
      if (!q) return;
      const rawType = q.Type !== undefined ? q.Type : q.type;
      const rawTypeId = q.TypeId !== undefined ? q.TypeId : q.typeId;
      let typeId = null;
      if (rawType) {
        typeId = (rawType && typeof rawType === 'object') ? Number(rawType.Id !== undefined ? rawType.Id : rawType.id) : Number(rawType);
      } else if (rawTypeId) {
        typeId = Number(rawTypeId);
      }

      const Answers = q.Answers !== undefined ? q.Answers : q.answers;
      const Fills = q.Fills !== undefined ? q.Fills : q.fills;
      const Categories = q.Categories !== undefined ? q.Categories : q.categories;
      const CustomStyle = q.CustomStyle !== undefined ? q.CustomStyle : q.customStyle;

      const solved = solvedQuestions && solvedQuestions[q.Id];
      const answers = examAnswers && examAnswers[q.Id];
      const isCorrect = solved ? (parseFloat(solved.userMark) >= (q.Mark || 2)) : false;

      // Clean HTML tags from question name
      const cleanQName = q.Name ? q.Name.replace(/<[^>]*>/g, '').trim() : "";

      const hintText = q.hint || q.Hint;
      let hintHtml = "";
      if (downloadHints && hintText) {
        const hintLabel = t ? t("Pages.Chatbot.HintTitle") : "التلميح المساعد";
        const showHintLabel = t ? t("Pages.Chatbot.ShowHint") : "عرض التلميح المساعد";
        if (downloadFormat === "html" && !downloadSolved && !downloadStudentAnswers) {
          hintHtml = `
            <div class="question-hint-container" style="margin-top: 8px; margin-bottom: 12px; text-align: right;">
                <button type="button" class="btn-show-hint" onclick="toggleHint(this)" style="background: none; border: none; color: #0284c7; padding: 0; font-family: inherit; font-size: 13.5px; cursor: pointer; text-decoration: underline; font-weight: bold; outline: none;">
                    <i class="fa-solid fa-lightbulb" style="margin-left: 4px;"></i> ${showHintLabel}
                </button>
                <div class="question-hint-box" style="display: none; margin-top: 8px; padding: 10px 15px; background-color: #f0f9ff; border: 1px solid #bae6fd; border-right: 4px solid #0284c7; border-radius: 8px; font-size: 13.5px; color: #0369a1;">
                    <strong style="color: #0284c7;"><i class="fa-solid fa-lightbulb ml-1"></i> ${hintLabel}:</strong> ${hintText}
                </div>
            </div>
          `;
        } else {
          hintHtml = `
            <div class="question-hint-box" style="margin-top: 8px; margin-bottom: 12px; padding: 10px 15px; background-color: #f0f9ff; border: 1px solid #bae6fd; border-right: 4px solid #0284c7; border-radius: 8px; font-size: 13.5px; color: #0369a1; text-align: right;">
                <strong style="color: #0284c7;"><i class="fa-solid fa-lightbulb ml-1"></i> ${hintLabel}:</strong> ${hintText}
            </div>
          `;
        }
      }

      htmlDocBody += `
          <div class="question-item" data-q-id="${q.Id || q.id}">
              <div class="question-name">${idx + 1}. ${cleanQName}</div>
              ${hintHtml}
      `;

      // Render Multiple Choice / Multi-Select questions (options)
      if (typeId === 1 || typeId === 7) {
        const isMulti = typeId === 1 || typeId === 7;
        htmlDocBody += `<div class="question-options" data-q-type="mcq" data-q-multi="${isMulti ? 'true' : 'false'}">`;
        (Answers || []).forEach((ans) => {
          if (!ans) return;
          const isTrue = ans.True === 1 || ans.true === 1 || ans.True === true || ans.true === true || ans.IsTrue === true || ans.isTrue === true || ans.IsTrue === 1 || ans.isTrue === 1;
          const isChecked = Array.isArray(answers) && answers.some(a => {
            const aId = a.Id !== undefined ? a.Id : a.id;
            const ansId = ans.Id !== undefined ? ans.Id : ans.id;
            return String(aId) === String(ansId) && a.isChecked;
          });
          
          let optionClass = "";
          let iconHtml = "";
          let dataAttrs = "";
          let optionStyle = "padding: 10px 15px; border-radius: 8px; margin-bottom: 6px; display: block; border: 1px solid #ebd9c5; background-color: #f8fafc; color: #0e2c53;";
          
          if (downloadStudentAnswers && isChecked) {
            if (downloadSolved) {
              if (isTrue) {
                optionClass = "correct-checked";
                optionStyle = "padding: 10px 15px; border-radius: 8px; margin-bottom: 6px; display: block; border: 1px solid #8dc63f; background-color: #e3f2cd; color: #2b5c0f; font-weight: bold;";
                iconHtml = downloadFormat === "word" 
                  ? `<span style="color: #2b5c0f; font-weight: bold;">[✓] </span>`
                  : `<i class="fa-solid fa-circle-check text-success" style="color: #8dc63f; margin-left: 6px;"></i>`;
              } else {
                optionClass = "incorrect-checked";
                optionStyle = "padding: 10px 15px; border-radius: 8px; margin-bottom: 6px; display: block; border: 1px solid #ef4444; background-color: #fdeeed; color: #991b1b;";
                iconHtml = downloadFormat === "word"
                  ? `<span style="color: #991b1b; font-weight: bold;">[❌] </span>`
                  : `<i class="fa-solid fa-circle-xmark text-danger" style="color: #ef4444; margin-left: 6px;"></i>`;
              }
            } else {
              optionClass = "checked";
              optionStyle = "padding: 10px 15px; border-radius: 8px; margin-bottom: 6px; display: block; border: 1px solid #0e2c53; background-color: #f0f3f6; color: #0e2c53; font-weight: bold;";
              iconHtml = downloadFormat === "word"
                ? `<span style="color: #0e2c53; font-weight: bold;">[✓] </span>`
                : `<i class="fa-solid fa-circle-check text-primary" style="color: #92278f; margin-left: 6px;"></i>`;
            }
          } else if (downloadSolved && isTrue) {
            optionClass = "correct";
            optionStyle = "padding: 10px 15px; border-radius: 8px; margin-bottom: 6px; display: block; border: 1px solid #8dc63f; background-color: #f4f9eb; color: #2b5c0f;";
            iconHtml = downloadFormat === "word"
              ? `<span style="color: #2b5c0f;">[✓] </span>`
              : `<i class="fa-solid fa-circle-check text-success" style="color: #8dc63f; margin-left: 6px;"></i>`;
          } else {
            if (downloadFormat === "html" && !downloadSolved && !downloadStudentAnswers) {
              optionClass = "interactive";
              const ansId = ans.Id !== undefined ? ans.Id : ans.id;
              dataAttrs = `data-true="${isTrue ? '1' : '0'}" data-ans-id="${ansId}"`;
              iconHtml = isMulti
                ? `<i class="fa-regular fa-square select-icon text-muted" style="cursor: pointer; margin-left: 8px; font-size: 16px;"></i>`
                : `<i class="fa-regular fa-circle select-icon text-muted" style="cursor: pointer; margin-left: 8px; font-size: 16px;"></i>`;
            } else {
              iconHtml = downloadFormat === "word"
                ? `<span>[ ] </span>`
                : `<i class="fa-regular fa-circle text-muted" style="margin-left: 6px;"></i>`;
            }
          }
          
          htmlDocBody += `
              <div class="answer-option ${optionClass}" ${dataAttrs} style="${optionStyle} ${optionClass === 'interactive' ? 'cursor: pointer; transition: all 0.2s;' : ''}">
                  ${iconHtml}
                  <span>${ans.Name}</span>
              </div>
          `;
        });
        htmlDocBody += `</div>`;
      } else if (typeId === 5 || typeId === 6 || typeId === 3) {
        // Render Drop-down Select-from-List & Drag-and-Drop questions
        let optionsPoolHtml = "";
        if (typeId === 3 && Answers && Answers.length > 0) {
          const optionsSpans = Answers.map(ans => `
            <span style="padding: 6px 12px; background-color: #ffffff; border: 1px solid #ebd9c5; border-radius: 20px; font-size: 14px; font-weight: bold; color: #0e2c53; display: inline-block; margin: 4px; font-family: 'Cairo', sans-serif !important;">
                ${ans.Name || ans.name}
            </span>
          `).join("");
          optionsPoolHtml = `
            <div class="drag-options-pool" style="margin-top: 10px; margin-bottom: 15px; padding: 12px 15px; background-color: #f8fafc; border: 1px dashed #ebd9c5; border-radius: 8px; text-align: right; direction: rtl;">
                <strong style="color: #0e2c53; font-size: 13.5px; display: block; margin-bottom: 8px; font-family: 'Cairo', sans-serif !important;">الخيارات المتاحة للسحب والإسقاط:</strong>
                <div style="text-align: right; direction: rtl;">
                    ${optionsSpans}
                </div>
            </div>
          `;
        }
        
        htmlDocBody += optionsPoolHtml;
        htmlDocBody += `<div class="question-options" data-q-type="select-from-list" style="margin-top: 10px; display: flex; flex-direction: column; gap: 10px;">`;
        const categories = Categories || [];
        const sortedCategories = [...categories].sort((a, b) => {
          const aSort = a.Sort !== undefined ? a.Sort : (a.sort !== undefined ? a.sort : 0);
          const bSort = b.Sort !== undefined ? b.Sort : (b.sort !== undefined ? b.sort : 0);
          return aSort - bSort;
        });
        sortedCategories.forEach((cat) => {
          if (!cat || !cat.Name) return;
          const count = cat.Name.split("(_)").length - 1;
          let sentenceHtml = cat.Name;
          const catId = cat.Id !== undefined ? cat.Id : cat.id;
          
          for (let index = 0; index < count; index++) {
            const isDragDrop = typeId === 3;
            const placeholderOptions = isDragDrop
              ? (Answers || [])
              : (Answers || []).filter(ans => {
                  const ansId = ans.Id !== undefined ? ans.Id : ans.id;
                  return (Fills || []).some(f => {
                    const fSort = f.Sort !== undefined ? f.Sort : f.sort;
                    const fCategoryId = f.CategoryId !== undefined ? f.CategoryId : f.categoryId;
                    const fAnswerId = f.AnswerId !== undefined ? f.AnswerId : f.answerId;
                    return fSort === (index + 1) && String(fCategoryId) === String(catId) && String(fAnswerId) === String(ansId);
                  });
                });
            
            const catCustomStyle = cat.CustomStyle || cat.customStyle;
            const catAnswers = (catCustomStyle && (catCustomStyle.Answers || catCustomStyle.answers)) || [];
            const correctAnsObj = catAnswers.find(a => {
              const aId = a.Id !== undefined ? a.Id : a.id;
              const aSort = a.Sort !== undefined ? a.Sort : a.sort;
              return String(aId) === String(catId) && aSort === index;
            });
            let correctAnswerId = correctAnsObj ? String(correctAnsObj.Answer !== undefined ? correctAnsObj.Answer : correctAnsObj.answer) : "";
            
            if (!correctAnswerId) {
              const qAnswers = (CustomStyle && (CustomStyle.Answers || CustomStyle.answers)) || [];
              const qAnsObj = qAnswers.find(a => {
                const aId = a.Id !== undefined ? a.Id : a.id;
                const aSort = a.Sort !== undefined ? a.Sort : a.sort;
                return String(aId) === String(catId) && aSort === index;
              });
              if (qAnsObj) {
                correctAnswerId = String(qAnsObj.Answer !== undefined ? qAnsObj.Answer : qAnsObj.answer);
              }
            }
            
            if (!correctAnswerId && Fills) {
              const fill = Fills.find(f => {
                const fCategoryId = f.CategoryId !== undefined ? f.CategoryId : f.categoryId;
                const fSort = f.Sort !== undefined ? f.Sort : f.sort;
                return String(fCategoryId) === String(catId) && fSort === (index + 1);
              });
              if (fill) {
                correctAnswerId = String(fill.AnswerId !== undefined ? fill.AnswerId : fill.answerId);
              }
            }
            
            const correctAnswerName = (Answers && Answers.find(ans => {
              const ansId = ans.Id !== undefined ? ans.Id : ans.id;
              return String(ansId) === correctAnswerId;
            }))?.Name || "";
            
            const studentAnsList = examAnswers && examAnswers[q.Id];
            const studentAnsObj = Array.isArray(studentAnsList) && studentAnsList.find(a => {
              const aCatId = a.CategoryId !== undefined ? a.CategoryId : (a.Id !== undefined ? a.Id : a.id);
              const aSort = a.Sort !== undefined ? a.Sort : a.sort;
              return String(aCatId) === String(catId) && aSort === (index + 1);
            });
            const studentAnswerId = studentAnsObj ? String(studentAnsObj.AnswerId !== undefined ? studentAnsObj.AnswerId : (studentAnsObj.Answer !== undefined ? studentAnsObj.Answer : studentAnsObj.answer)) : "";
            const studentAnswerName = (Answers && Answers.find(ans => {
              const ansId = ans.Id !== undefined ? ans.Id : ans.id;
              return String(ansId) === studentAnswerId;
            }))?.Name || "";
            
            const isPlaceholderCorrect = studentAnswerId === correctAnswerId;
            let placeholderReplace = "";
            
            if (downloadStudentAnswers && studentAnswerId) {
              if (downloadSolved) {
                if (isPlaceholderCorrect) {
                  placeholderReplace = `<span style="background-color: #e3f2cd; color: #2b5c0f; font-weight: bold; border-bottom: 2px solid #8dc63f; padding: 2px 8px; border-radius: 4px; font-family: 'Cairo', sans-serif;">${studentAnswerName}</span>`;
                } else {
                  placeholderReplace = `<span style="background-color: #fdeeed; color: #991b1b; font-weight: bold; border-bottom: 2px solid #ef4444; padding: 2px 8px; border-radius: 4px; font-family: 'Cairo', sans-serif; text-decoration: line-through;">${studentAnswerName || "لم يتم الإجابة"}</span> <span style="background-color: #eff8e2; color: #2b5c0f; font-weight: bold; border-bottom: 2px dashed #8dc63f; padding: 2px 8px; border-radius: 4px; font-family: 'Cairo', sans-serif; margin-right: 4px;">${correctAnswerName}</span>`;
                }
              } else {
                placeholderReplace = `<span style="background-color: #f0f3f6; color: #0e2c53; font-weight: bold; border-bottom: 2px solid #0e2c53; padding: 2px 8px; border-radius: 4px; font-family: 'Cairo', sans-serif;">${studentAnswerName}</span>`;
              }
            } else if (downloadSolved) {
              placeholderReplace = `<span style="background-color: #eff8e2; color: #2b5c0f; font-weight: bold; border-bottom: 2px solid #8dc63f; padding: 2px 8px; border-radius: 4px; font-family: 'Cairo', sans-serif;">${correctAnswerName}</span>`;
            } else {
              if (downloadFormat === "html") {
                let selectOptionsHtml = `<option value="">-- اختر --</option>`;
                placeholderOptions.forEach(opt => {
                  const optId = opt.Id !== undefined ? opt.Id : opt.id;
                  selectOptionsHtml += `<option value="${optId}">${opt.Name}</option>`;
                });
                
                placeholderReplace = `
                  <select class="fill-select-interactive" data-correct-id="${correctAnswerId}" data-correct-name="${correctAnswerName}" data-cat-id="${catId}" data-sort="${index + 1}" style="padding: 4px 8px; border: 2px solid #ebd9c5; border-radius: 6px; font-family: 'Cairo', sans-serif; font-size: 14px; background: #fff; cursor: pointer; outline: none; margin: 0 4px; transition: border-color 0.2s;">
                    ${selectOptionsHtml}
                  </select>
                `;
              } else {
                placeholderReplace = `<span style="border-bottom: 2px solid #0e2c53; padding: 0 15px; color: transparent; font-family: 'Cairo', sans-serif;">..........</span>`;
              }
            }
            sentenceHtml = sentenceHtml.replace("(_)", placeholderReplace);
          }
          
          htmlDocBody += `<p style="margin: 8px 0; line-height: 2.2; font-family: 'Cairo', sans-serif; text-align: right; direction: rtl;">${sentenceHtml}</p>`;
        });
        htmlDocBody += `</div>`;
      } else {
        // Render Text/Fill questions (student text answer)
        let studentAnsText = "";
        if (answers) {
          if (typeof answers === 'string') {
            studentAnsText = answers;
          } else if (Array.isArray(answers)) {
            if (typeId === 4 || typeId === 34) {
              studentAnsText = answers.map(a => a.Answer || "").filter(Boolean).join("، ");
            } else {
              studentAnsText = answers.map(a => {
                if (typeof a === 'string') return a;
                if (typeof a === 'object' && a !== null) {
                  return a.Answer || a.Name || a.text || a.userAnswer || "";
                }
                return "";
              }).filter(Boolean).join("، ");
            }
          } else if (typeof answers === 'object' && answers !== null) {
            studentAnsText = answers.Answer || answers.Name || answers.text || JSON.stringify(answers);
          } else {
            studentAnsText = String(answers);
          }
        }
        
        let correctAnswersText = "";
        if (Fills && Fills.length > 0) {
          correctAnswersText = Fills.map(f => f.AnswerName || f.AnswerText || f.Name || f.text || "").filter(Boolean).join("، ");
        }
        
        if (downloadStudentAnswers) {
          const hasUserAnswer = studentAnsText && studentAnsText.trim() !== "";
          
          if (downloadSolved) {
            const statusClass = isCorrect ? "correct" : "incorrect";
            const containerStyle = isCorrect
              ? "margin-top: 10px; padding: 12px 15px; border-radius: 8px; font-size: 14px; background-color: #eff8e2; border: 1px solid #8dc63f; color: #2b5c0f;"
              : "margin-top: 10px; padding: 12px 15px; border-radius: 8px; font-size: 14px; background-color: #fdeeed; border: 1px solid #ef4444; color: #991b1b;";
            htmlDocBody += `
              <div class="student-answer-container ${statusClass}" style="${containerStyle}">
                  <div class="student-answer-label" style="font-weight: bold; margin-bottom: 4px; font-size: 12.5px;">إجابة الطالب:</div>
                  <div>${hasUserAnswer ? studentAnsText : "لم يتم الإجابة"}</div>
              </div>
            `;
            
            if (!isCorrect && correctAnswersText) {
              htmlDocBody += `
                <div class="student-answer-container correct" style="margin-top: 8px; padding: 12px 15px; border-radius: 8px; font-size: 14px; background-color: #eff8e2; border: 1px solid #8dc63f; color: #2b5c0f;">
                    <div class="student-answer-label" style="font-weight: bold; margin-bottom: 4px; font-size: 12.5px;">الإجابة الصحيحة النموذجية:</div>
                    <div>${correctAnswersText}</div>
                </div>
              `;
            }
          } else {
            htmlDocBody += `
              <div class="student-answer-container" style="margin-top: 10px; padding: 12px 15px; border-radius: 8px; font-size: 14px; background-color: #f0f3f6; border: 1px solid #ebd9c5; color: #0e2c53;">
                  <div class="student-answer-label" style="font-weight: bold; margin-bottom: 4px; font-size: 12.5px;">إجابة الطالب:</div>
                  <div>${hasUserAnswer ? studentAnsText : "لم يتم الإجابة"}</div>
              </div>
            `;
          }
        } else if (downloadSolved) {
          if (correctAnswersText) {
            htmlDocBody += `
              <div class="student-answer-container correct" style="margin-top: 10px; padding: 12px 15px; border-radius: 8px; font-size: 14px; background-color: #eff8e2; border: 1px solid #8dc63f; color: #2b5c0f;">
                  <div class="student-answer-label" style="font-weight: bold; margin-bottom: 4px; font-size: 12.5px;">الإجابة النموذجية:</div>
                  <div>${correctAnswersText}</div>
              </div>
            `;
          }
        } else {
          if (downloadFormat === "html") {
            htmlDocBody += `
              <div class="interactive-text-container" style="margin-top: 10px;" data-correct-val="${correctAnswersText}">
                  <input type="text" class="fill-input" placeholder="اكتب إجابتك هنا..." style="width: 100%; max-width: 500px; padding: 10px 12px; border: 2px solid #ebd9c5; border-radius: 8px; font-family: inherit; font-size: 14.5px; outline: none; box-sizing: border-box; transition: all 0.3s;" />
                  <div class="feedback-text" style="display: none; margin-top: 8px; font-weight: bold; font-size: 13.5px; font-family: 'Cairo', sans-serif;"></div>
              </div>
            `;
          } else {
            htmlDocBody += `
              <div style="margin-top: 15px; border-bottom: 1px solid #ebd9c5; padding-bottom: 5px; min-height: 40px; color: #94a3b8; font-size: 14px;">
                  إجابة الطالب: ....................................................................................................
              </div>
            `;
          }
        }
      }
      
      htmlDocBody += `
          </div>
      `;
    });

    if (downloadFormat === "html" && !downloadSolved && !downloadStudentAnswers) {
      const textResetAttempt = t ? t("Pages.Chatbot.ResetAttempt") : "إعادة تعيين المحاولة";
      htmlDocBody += `
          <div style="text-align: center; margin-top: 25px;">
              <button id="btn-grade-sheet" style="background-color: #92278f; color: white; border: none; padding: 12px 35px; border-radius: 30px; font-family: 'Cairo', sans-serif; font-size: 15px; font-weight: bold; cursor: pointer; transition: all 0.3s; box-shadow: 0 4px 12px rgba(146, 39, 143, 0.2); outline: none;">
                  <i class="fa-solid fa-check-double" style="margin-left: 8px;"></i> ${textFinishAndCalculate}
              </button>
              <button id="btn-reset-sheet" style="background-color: #64748b; color: white; border: none; padding: 12px 35px; border-radius: 30px; font-family: 'Cairo', sans-serif; font-size: 15px; font-weight: bold; cursor: pointer; transition: all 0.3s; box-shadow: 0 4px 12px rgba(100, 116, 139, 0.2); outline: none; margin-right: 15px;">
                  <i class="fa-solid fa-redo" style="margin-left: 8px;"></i> ${textResetAttempt}
              </button>
              
              <div id="grading-result-container" style="display: none; margin-top: 25px; padding: 25px; border-radius: 12px; border: 1px solid #ebd9c5; background-color: #fffdf9; transition: all 0.3s; box-shadow: 0 4px 15px rgba(0,0,0,0.03);">
                  <div id="grading-score-circle" style="width: 100px; height: 100px; border: 4px solid #92278f; border-radius: 50%; margin: 0 auto 15px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-weight: bold; font-size: 24px; font-family: 'Cairo', sans-serif; color: #92278f;">
                      <span id="grading-score-val">0</span>
                      <span style="font-size: 11px; font-weight: normal; color: #64748b; margin-top: -3px;">%</span>
                  </div>
                  <h4 id="grading-feedback-title" style="margin: 0 0 5px; font-weight: bold; font-size: 17px; font-family: 'Cairo', sans-serif; color: #0e2c53;"></h4>
                  <p id="grading-feedback-desc" style="margin: 0; font-size: 14px; color: #64748b; font-family: 'Cairo', sans-serif;"></p>
              </div>
          </div>
      `;
    }

    htmlDocBody += `
          </div>
      </div>
    `;
  }

  // 3. Render Relative Lessons if downloadRelativeLessons is enabled - THIRD
  let relativeLinksList = [];
  if (relativeLessons && Array.isArray(relativeLessons) && relativeLessons.length > 0) {
    relativeLinksList = relativeLessons.map((lesson) => {
      const type = lesson.Type || lesson.type || "";
      let href = lesson.Link || lesson.Url || lesson.href || lesson.link || "";
      if (!href) {
        if (type === "File") {
          href = lesson.Token || lesson.token ? `/EducationalFiles/?token=${lesson.Token || lesson.token}` : `/EducationalFileView/${lesson.Id || lesson.id}`;
        } else {
          const urlPrefix = (type === "Game" || type === "Fun") ? "GameView" : (type === "Exam" ? "ExamView" : (type === "SelfDevelopment" ? "SelfDevelopmentView" : "LessonView"));
          href = `/${urlPrefix}/${lesson.Id || lesson.id}`;
        }
      }
      return {
        href: (typeof href === "string" && href) ? (href.startsWith("http") ? href : `https://alarabeyya.com${href}`) : "https://alarabeyya.com",
        text: lesson.Name || lesson.Text || lesson.text || lesson.name || "عرض الدرس",
        type: type
      };
    });
  } else {
    const relativeLinks = getRelativeLinks(messages);
    relativeLinksList = relativeLinks.map(link => ({
      href: (typeof link.href === "string" && link.href) ? (link.href.startsWith("http") ? link.href : `https://alarabeyya.com${link.href}`) : "https://alarabeyya.com",
      text: link.text,
      type: link.type
    }));
  }

  if (downloadRelativeLessons && relativeLinksList && relativeLinksList.length > 0) {
    const relativeTitle = t ? t("Pages.Chatbot.DownloadRelativeLessonsTitle", { lesson: docTitle }) : `الدروس ذات الصلة بدرس ${docTitle}`;
    
    if (downloadFormat === "word") {
      let tableCellsHtml = "";
      relativeLinksList.forEach((link) => {
        tableCellsHtml += `
          <td align="center" valign="middle" style="background-color: #f8fafc; border: 1px solid #ebd9c5; padding: 12px 15px; border-radius: 12px;">
              <a href="${link.href}" target="_blank" style="color: #0e2c53; text-decoration: none; font-weight: bold; font-family: 'Cairo', sans-serif !important; font-size: 11pt; display: block; text-align: center; direction: rtl;">
                  <span style="font-family: 'Cairo', sans-serif !important; color: #ffd54f;">★</span>
                  <span style="font-family: 'Cairo', sans-serif !important;">${link.text}</span>
              </a>
          </td>
        `;
      });
      
      htmlDocBody += `
        <div class="section-container" style="background-color: #ffffff; border: 1px solid #ebd9c5; padding: 30px; margin-bottom: 30px;">
            <h2 class="section-title" style="color: #0e2c53; font-size: 20px; font-weight: 700; border-bottom: 2px solid #8dc63f; padding-bottom: 8px; margin-top: 0; margin-bottom: 20px; text-align: right; direction: rtl;">${relativeTitle}</h2>
            <table width="100%" style="width: 100%; border-collapse: separate; border-spacing: 10px; margin: 10px 0; background: transparent; border: none; direction: rtl;">
                <tr style="border: none; background: transparent;">
                    ${tableCellsHtml}
                </tr>
            </table>
        </div>
      `;
    } else {
      htmlDocBody += `
        <div class="section-container" style="padding: 20px; margin-bottom: 20px; border: 1px solid #ebd9c5; background-color: #ffffff; border-radius: 16px;">
            <h2 class="section-title" style="color: #0e2c53; font-size: 20px; font-weight: 700; border-bottom: 2px solid #8dc63f; padding-bottom: 8px; margin-top: 0; margin-bottom: 20px; direction: rtl; text-align: right;">
                <i class="fa-solid fa-link" style="color: #8dc63f; margin-left: 8px;"></i>
                <span>${relativeTitle}</span>
            </h2>
            <div class="relative-lessons-grid" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 15px;">
      `;
      relativeLinksList.forEach((link) => {
        htmlDocBody += `
            <a href="${link.href}" target="_blank" class="relative-lesson-card" style="display: flex; flex-direction: column; align-items: flex-start; gap: 4px; padding: 12px 15px; background: #f8fafc; border: 1px solid rgba(14, 44, 83, 0.05); border-radius: 12px; color: #0e2c53; text-decoration: none; font-weight: bold;">
                <div style="display: flex; align-items: center; gap: 8px; font-weight: bold; direction: rtl;">
                    <i class="fa-solid fa-graduation-cap" style="color: #ffd54f; margin-left: 6px;"></i>
                    <span>${link.text}</span>
                </div>
            </a>
        `;
      });
      htmlDocBody += `
            </div>
        </div>
      `;
    }
  }

  // 4. Render Chat Messages if downloadChat is enabled - FOURTH
  if (downloadChat && messages && messages.length > 0) {
    let displayedMessages = messages;
    const firstBotMsg = originalBotMsg;
    const firstLessonIndex = firstBotMsg ? messages.indexOf(firstBotMsg) : -1;
    if (firstLessonIndex !== -1) {
      displayedMessages = messages.filter((m, idx) => {
        if (idx === firstLessonIndex) return false;
        if (idx === firstLessonIndex - 1 && messages[idx].sender === "user") return false;
        return true;
      });
    } else {
      let firstUserIndex = messages.findIndex(msg => msg.sender === "user");
      let firstBotIndex = messages.findIndex(msg => msg.sender === "bot");
      displayedMessages = messages.filter((msg, idx) => {
        if (idx === firstUserIndex) return false;
        if (idx === firstBotIndex) return false;
        return true;
      });
    }

    if (displayedMessages.length > 0) {
      htmlDocBody += `
          <div class="section-container" style="background-color: #ffffff; border: 1px solid #ebd9c5; padding: 30px; margin-bottom: 30px; border-radius: 16px;">
              <h2 class="section-title">
                  <i class="fa-solid fa-comments"></i>
                  <span>المحادثة والاستفسارات</span>
              </h2>
              <div class="chat-messages-list">
        `;
      displayedMessages.forEach((msg) => {
        const isBot = msg.sender === "bot";
        const senderName = isBot ? "المساعد الذكي" : userName;
        const senderIcon = isBot ? "fa-robot" : "fa-user";
        const cleanedText = isBot ? cleanBotHtml(msg.text) : msg.text;
        htmlDocBody += `
                    <div class="message-item ${msg.sender}" style="${msg.sender === 'user' ? 'background-color: #92278f; color: #ffffff; padding: 10px 15px; margin-bottom: 15px; border-radius: 8px; max-width: 85%; margin-left: auto; margin-right: 0;' : 'background-color: #f8fafc; border-right: 4px solid #8dc63f; border-top: 1px solid #ebd9c5; border-bottom: 1px solid #ebd9c5; border-left: 1px solid #ebd9c5; padding: 10px 15px; margin-bottom: 15px; border-radius: 8px; max-width: 85%; margin-right: auto; margin-left: 0;'}">
                        <div class="message-sender ${msg.sender}" style="font-weight: 700; font-size: 13px; margin-bottom: 8px; display: flex; align-items: center; gap: 8px; ${msg.sender === 'user' ? 'color: #ffd54f;' : 'color: #8dc63f;'}">
                            <i class="fa-solid ${senderIcon}" style="margin-left: 6px;"></i>
                            <span>${senderName}</span>
                        </div>
                        <div class="message-content" style="font-size: 15px;">
                            ${isBot ? cleanedText : `<p>${cleanedText}</p>`}
                        </div>
                    </div>
                `;
      });
      htmlDocBody += `
              </div>
          </div>
        `;
    }
  }

  // Add Brand Footer
  htmlDocBody += `
    <div class="download-page-footer" style="margin-top: 50px; padding: 20px; background-color: #f8fafc; border-top: 3px solid #8dc63f; border-radius: 12px; text-align: center; font-size: 12px; color: #64748b; direction: rtl;">
        <div class="footer-info-grid" style="margin-top: 10px; margin-bottom: 15px;">
            <div class="footer-info-item" style="display: inline-block; width: 32%; font-size: 13px; color: #0e2c53; font-weight: bold;"><i class="fa-solid fa-envelope" style="margin-left: 4px;"></i> support@alarabeyya.com</div>
            <div class="footer-info-item" style="display: inline-block; width: 32%; font-size: 13px; color: #0e2c53; font-weight: bold;"><i class="fa-solid fa-phone" style="margin-left: 4px;"></i> +972-508-680-705 | +970-569-859-556</div>
            <div class="footer-info-item" style="display: inline-block; width: 32%; font-size: 13px; color: #0e2c53; font-weight: bold;"><i class="fa-solid fa-location-dot" style="margin-left: 4px;"></i> شارع 18، جت | صندوق بريد 1548</div>
        </div>
        <div class="footer-divider" style="height: 1px; background: rgba(14, 44, 83, 0.1); margin: 10px 0;"></div>
        <p class="footer-copyright" style="margin: 10px 0 0 0; font-weight: bold; color: #64748b;">جميع الحقوق القانونية وحقوق الملكية الفكرية محفوظة لـموقع هيّا إلى العربيّة © ${new Date().getFullYear()}</p>
    </div>
  `;

  // Assemble full document based on chosen format
  let documentContent = "";
  if (downloadFormat === "word") {
    documentContent = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns:v="urn:schemas-microsoft-com:vml" xmlns="http://www.w3.org/TR/REC-html40" lang="ar" dir="rtl">
      <head>
          <meta charset="utf-8">
          <title>${docTitle}</title>
          <!--[if gte mso 9]>
          <xml>
              <w:WordDocument>
                  <w:View>Print</w:View>
                  <w:Zoom>100</w:Zoom>
                  <w:DoNotAllowWebParagraphAutofit/>
                  <w:DisplayBackgroundShape/>
              </w:WordDocument>
          </xml>
          <![endif]-->
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700;800&display=swap" rel="stylesheet">
          <style>
              @page Section1 {
                  size: 8.5in 11.0in;
                  margin: 1.0in 1.0in 1.0in 1.0in;
                  mso-header-margin: 0.5in;
                  mso-footer-margin: 0.5in;
                  mso-header: h1;
                  mso-footer: f1;
              }
              div.Section1 {
                  page: Section1;
              }
              p.MsoHeader, li.MsoHeader, div.MsoHeader {
                  margin: 0in;
                  margin-bottom: .0001pt;
                  mso-pagination: widow-orphan;
                  font-family: 'Cairo', sans-serif !important;
                  font-size: 10pt;
                  direction: rtl;
                  text-align: right;
              }
              p.MsoFooter, li.MsoFooter, div.MsoFooter {
                  margin: 0in;
                  margin-bottom: .0001pt;
                  mso-pagination: widow-orphan;
                  font-family: 'Cairo', sans-serif !important;
                  font-size: 10pt;
                  direction: rtl;
                  text-align: right;
              }
              body {
                  font-family: 'Cairo', sans-serif !important;
                  padding: 40px 20px;
                  color: #0e2c53;
                  line-height: 1.8;
                  max-width: 900px;
                  margin: 0 auto;
                  font-size: ${FontSize || 18}px;
                  direction: rtl;
                  unicode-bidi: embed;
                  text-align: right;
              }
              p, div, li, table, tr, td, h1, h2, h3, h4, h5, h6 {
                  direction: rtl;
                  unicode-bidi: embed;
                  text-align: right;
                  font-family: 'Cairo', sans-serif !important;
              }
              ${wordStyles}
          </style>
      </head>
      <body dir="rtl" style="direction: rtl; unicode-bidi: embed; text-align: right; font-family: 'Cairo', sans-serif !important;">
          <!--[if gte mso 9]>
          <v:background id="_x0000_s1025" fillcolor="#ffffff" o:singleclick="false">
              <v:fill src="https://alarabeyya.com/assets/images/logo/logo.png" type="frame" opacity="0.04" />
          </v:background>
          <![endif]-->
          <div class="Section1" dir="rtl" style="direction: rtl; unicode-bidi: embed; text-align: right;">
              <!-- Header Definition -->
              <div style="mso-element:header; display:none; margin:0; padding:0; height:0; overflow:hidden; font-size:1px; line-height:1px;" id="h1">
                  ${wordHeaderHtml}
              </div>
 
              <!-- Footer Definition -->
              <div style="mso-element:footer; display:none; margin:0; padding:0; height:0; overflow:hidden; font-size:1px; line-height:1px;" id="f1">
                  ${wordFooterHtml}
              </div>

              ${htmlDocBody}
          </div>
      </body>
      </html>
    `;
  } else {
    // Generate JavaScript for HTML versions if questions are unsolved/interactive
    let interactiveScript = "";
    if (!downloadSolved && !downloadStudentAnswers && downloadQuestions && activeQuestions && activeQuestions.length > 0) {
      const textExcellent = t ? t("Pages.Chatbot.Excellent") : "ممتاز جداً! 🌟";
      const textVeryGood = t ? t("Pages.Chatbot.VeryGood") : "جيد جداً! 👍";
      const textAcceptable = t ? t("Pages.Chatbot.Acceptable") : "مستوى مقبول! 📝";
      const textNeedFocus = t ? t("Pages.Chatbot.NeedFocus") : "تحتاج لمزيد من المراجعة والتركيز! 📚";

      const descExcellent = t ? t("Pages.Chatbot.TrophyExcellentText") : "لقد أتممت جميع الأسئلة والتمارين بنجاح وحققت أداءً ممتازاً جداً! أنت عبقري حقيقي!";
      const descVeryGood = t ? t("Pages.Chatbot.TrophyVeryGoodText") : "لقد أتممت الأسئلة بأداء رائع وجيد جداً! استمر في هذا التميز!";
      const descAcceptable = t ? t("Pages.Chatbot.TrophyAcceptableText") : "لقد أتممت التمارين بنجاح. أداؤك مقبول، وبإمكانك تحقيق الأفضل بالمزيد من الممارسة!";
      const descNeedFocus = t ? t("Pages.Chatbot.TrophyNeedFocusText") : "لقد أكملت المحاولة. تحتاج إلى مراجعة الدرس والتركيز أكثر على القواعد لتطوير مستواك!";

      interactiveScript = `
        <script>
          window.toggleHint = (btn) => {
            const container = btn.parentElement;
            const box = container.querySelector('.question-hint-box');
            if (box.style.display === 'none') {
              box.style.display = 'block';
              btn.style.display = 'none';
            } else {
              box.style.display = 'none';
            }
          };

          document.addEventListener('DOMContentLoaded', () => {
            // 1. MCQ interactive clicking
            const optionsList = document.querySelectorAll('.question-options');
            optionsList.forEach(container => {
              const isMulti = container.getAttribute('data-q-multi') === 'true';
              const options = container.querySelectorAll('.answer-option.interactive');
              
              options.forEach(opt => {
                opt.addEventListener('click', () => {
                  if (window.graded) return;
                  
                  if (isMulti) {
                    opt.classList.toggle('selected');
                    const icon = opt.querySelector('.select-icon');
                    if (opt.classList.contains('selected')) {
                      icon.className = 'fa-solid fa-square-check select-icon';
                    } else {
                      icon.className = 'fa-regular fa-square select-icon';
                    }
                  } else {
                    options.forEach(o => {
                      o.classList.remove('selected');
                      const oIcon = o.querySelector('.select-icon');
                      oIcon.className = 'fa-regular fa-circle select-icon';
                    });
                    opt.classList.add('selected');
                    const icon = opt.querySelector('.select-icon');
                    icon.className = 'fa-solid fa-circle-dot select-icon';
                  }
                });
              });
            });

            // 2. Grading action
            const gradeBtn = document.getElementById('btn-grade-sheet');
            if (gradeBtn) {
              gradeBtn.addEventListener('click', () => {
                if (window.graded) return;
                window.graded = true;
                
                let totalQuestions = 0;
                let correctCount = 0;
                
                // Grade MCQs
                const mcqContainers = document.querySelectorAll('.question-options');
                mcqContainers.forEach(container => {
                  totalQuestions++;
                  const isMulti = container.getAttribute('data-q-multi') === 'true';
                  const options = container.querySelectorAll('.answer-option.interactive');
                  let isQCorrect = true;
                  
                  options.forEach(opt => {
                    const isCorrectAns = opt.getAttribute('data-true') === '1';
                    const isChecked = opt.classList.contains('selected');
                    const icon = opt.querySelector('.select-icon');
                    
                    if (isChecked) {
                      if (isCorrectAns) {
                        opt.classList.add('graded-correct');
                        if (icon) icon.className = isMulti ? 'fa-solid fa-square-check select-icon' : 'fa-solid fa-circle-check select-icon';
                      } else {
                        opt.classList.add('graded-incorrect');
                        if (icon) icon.className = isMulti ? 'fa-solid fa-square-xmark select-icon' : 'fa-solid fa-circle-xmark select-icon';
                        isQCorrect = false;
                      }
                    } else {
                      if (isCorrectAns) {
                        opt.classList.add('graded-should-be');
                        if (icon) icon.className = isMulti ? 'fa-regular fa-square-check select-icon' : 'fa-regular fa-circle-check select-icon';
                        isQCorrect = false;
                      }
                    }
                  });
                  
                  if (isQCorrect) correctCount++;
                });

                // Grade Fill-in questions
                const textContainers = document.querySelectorAll('.interactive-text-container');
                textContainers.forEach(container => {
                  totalQuestions++;
                  const input = container.querySelector('.fill-input');
                  const feedback = container.querySelector('.feedback-text');
                  const userVal = (input.value || "").trim();
                  const correctStr = container.getAttribute('data-correct-val') || "";
                  
                  const normalize = (t) => {
                    if (!t) return "";
                    let clean = t.toString().toLowerCase();
                    // Remove tashkeel
                    clean = clean.replace(/[\\u064B-\\u065F]/g, "");
                    // Normalize Alef
                    clean = clean.replace(/[أإآ]/g, "ا");
                    // Normalize Teh Marbuta
                    clean = clean.replace(/ة/g, "ه");
                    // Normalize Yeh/Alef Maksura
                    clean = clean.replace(/ى/g, "ي");
                    // Remove punctuation
                    clean = clean.replace(/[.,\\/#!$%\\^&\\*;:{}=\\-_~\\\`()؟?،]/g, "");
                    // Collapse spaces
                    clean = clean.replace(/\\s+/g, " ").trim();
                    return clean;
                  };
                  
                  const normUser = normalize(userVal);
                  const correctOptions = correctStr.split(/[،,]/).map(x => normalize(x)).filter(Boolean);
                  
                  let isTextCorrect = false;
                  if (normUser) {
                    isTextCorrect = correctOptions.some(opt => opt === normUser);
                  }
                  
                  feedback.style.display = 'block';
                  if (isTextCorrect) {
                    input.style.borderColor = '#8dc63f';
                    input.style.backgroundColor = 'rgba(141, 198, 63, 0.08)';
                    feedback.innerHTML = '<span style="color: #2b5c0f;"><i class="fa-solid fa-circle-check ml-1"></i> إجابة صحيحة!</span>';
                    correctCount++;
                  } else {
                    input.style.borderColor = '#ef4444';
                    input.style.backgroundColor = 'rgba(239, 68, 68, 0.08)';
                    feedback.innerHTML = '<span style="color: #991b1b;"><i class="fa-solid fa-circle-xmark ml-1"></i> إجابة خاطئة!</span>' + 
                      '<div style="color: #2b5c0f; margin-top: 4px; font-weight: normal; font-size: 13px;">الإجابة الصحيحة النموذجية: ' + correctStr + '</div>';
                  }
                  input.disabled = true;
                });

                // Grade Select-from-list questions
                const selectInputs = document.querySelectorAll('.fill-select-interactive');
                selectInputs.forEach(select => {
                  totalQuestions++;
                  const userVal = select.value;
                  const correctId = select.getAttribute('data-correct-id');
                  const correctName = select.getAttribute('data-correct-name');
                  
                  if (userVal === correctId) {
                    select.style.borderColor = '#8dc63f';
                    select.style.backgroundColor = 'rgba(141, 198, 63, 0.08)';
                    correctCount++;
                  } else {
                    select.style.borderColor = '#ef4444';
                    select.style.backgroundColor = 'rgba(239, 68, 68, 0.08)';
                    
                    const hintSpan = document.createElement('span');
                    hintSpan.className = 'select-feedback-hint';
                    hintSpan.style.color = '#2b5c0f';
                    hintSpan.style.fontWeight = 'bold';
                    hintSpan.style.fontSize = '12.5px';
                    hintSpan.style.marginRight = '8px';
                    hintSpan.innerHTML = '<i class="fa-solid fa-circle-info ml-1"></i> (الجواب: ' + correctName + ')';
                    select.parentNode.insertBefore(hintSpan, select.nextSibling);
                  }
                  select.disabled = true;
                });

                // Calculate Result
                const percentage = totalQuestions > 0 ? Math.round((correctCount / totalQuestions) * 100) : 0;
                
                const resultContainer = document.getElementById('grading-result-container');
                const scoreCircle = document.getElementById('grading-score-circle');
                const scoreVal = document.getElementById('grading-score-val');
                const feedbackTitle = document.getElementById('grading-feedback-title');
                const feedbackDesc = document.getElementById('grading-feedback-desc');
                
                scoreVal.textContent = percentage;
                
                if (percentage >= 90) {
                  scoreCircle.style.borderColor = '#28a745';
                  scoreCircle.style.color = '#28a745';
                  scoreCircle.style.backgroundColor = 'rgba(40, 167, 69, 0.05)';
                  feedbackTitle.textContent = \`${textExcellent}\`;
                  feedbackDesc.textContent = \`${descExcellent}\`;
                } else if (percentage >= 75) {
                  scoreCircle.style.borderColor = '#28a745';
                  scoreCircle.style.color = '#28a745';
                  scoreCircle.style.backgroundColor = 'rgba(40, 167, 69, 0.05)';
                  feedbackTitle.textContent = \`${textVeryGood}\`;
                  feedbackDesc.textContent = \`${descVeryGood}\`;
                } else if (percentage >= 50) {
                  scoreCircle.style.borderColor = '#ffc107';
                  scoreCircle.style.color = '#d39e00';
                  scoreCircle.style.backgroundColor = 'rgba(255, 193, 7, 0.05)';
                  feedbackTitle.textContent = \`${textAcceptable}\`;
                  feedbackDesc.textContent = \`${descAcceptable}\`;
                } else {
                  scoreCircle.style.borderColor = '#dc3545';
                  scoreCircle.style.color = '#dc3545';
                  scoreCircle.style.backgroundColor = 'rgba(220, 53, 69, 0.05)';
                  feedbackTitle.textContent = \`${textNeedFocus}\`;
                  feedbackDesc.textContent = \`${descNeedFocus}\`;
                }
                
                resultContainer.style.display = 'block';
                resultContainer.scrollIntoView({ behavior: 'smooth' });
                
                gradeBtn.style.opacity = '0.6';
                gradeBtn.style.cursor = 'not-allowed';
              });
            }

            // 3. Reset action
            const resetBtn = document.getElementById('btn-reset-sheet');
            if (resetBtn) {
              resetBtn.addEventListener('click', () => {
                window.graded = false;
                
                // Reset MCQs
                const options = document.querySelectorAll('.answer-option.interactive');
                options.forEach(opt => {
                  opt.classList.remove('selected', 'graded-correct', 'graded-incorrect', 'graded-should-be');
                  const icon = opt.querySelector('.select-icon');
                  const container = opt.closest('.question-options');
                  const isMulti = container && container.getAttribute('data-q-multi') === 'true';
                  if (icon) {
                    icon.className = isMulti ? 'fa-regular fa-square select-icon' : 'fa-regular fa-circle select-icon';
                  }
                });
                
                // Reset Text Inputs
                const textContainers = document.querySelectorAll('.interactive-text-container');
                textContainers.forEach(container => {
                  const input = container.querySelector('.fill-input');
                  const feedback = container.querySelector('.feedback-text');
                  if (input) {
                    input.value = "";
                    input.disabled = false;
                    input.style.borderColor = '#ebd9c5';
                    input.style.backgroundColor = '';
                  }
                  if (feedback) {
                    feedback.style.display = 'none';
                    feedback.innerHTML = '';
                  }
                });

                // Reset Select dropdowns
                const selectInputs = document.querySelectorAll('.fill-select-interactive');
                selectInputs.forEach(select => {
                  select.value = "";
                  select.disabled = false;
                  select.style.borderColor = '#ebd9c5';
                  select.style.backgroundColor = '#fff';
                });
                // Remove select feedback hints if any
                const selectHints = document.querySelectorAll('.select-feedback-hint');
                selectHints.forEach(hint => hint.remove());
                
                // Hide grading results
                const resultContainer = document.getElementById('grading-result-container');
                if (resultContainer) {
                  resultContainer.style.display = 'none';
                }
                
                // Enable grading button
                if (gradeBtn) {
                  gradeBtn.style.opacity = '1';
                  gradeBtn.style.cursor = 'pointer';
                }
              });
            }
          });
        </script>
      `;
    }

    documentContent = `
      <!DOCTYPE html>
      <html lang="ar" dir="rtl">
      <head>
          <meta charset="utf-8">
          <title>${docTitle}</title>
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700;800&family=Tajawal:wght@300;400;500;700&display=swap" rel="stylesheet">
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@7.2.0/css/all.min.css" />
          <style>
              body {
                  font-family: 'Cairo', 'Tajawal', sans-serif;
                  padding: 40px 20px;
                  background-color: #fdfaf5;
                  color: #0e2c53;
                  line-height: 1.8;
                  max-width: 900px;
                  margin: 0 auto;
                  font-size: ${FontSize || 18}px;
              }
              ${customStyles}
          </style>
      </head>
      <body>
          ${htmlDocBody}
          ${interactiveScript}
      </body>
      </html>
    `;
  }

  // PDF Download/Print workflow
  if (downloadFormat === "pdf") {
    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.write(documentContent);
      printWindow.document.close();
      
      const printScript = printWindow.document.createElement("script");
      printScript.innerHTML = `
        window.addEventListener('load', () => {
          setTimeout(() => {
            window.focus();
            window.print();
            window.close();
          }, 800);
        });
      `;
      printWindow.document.body.appendChild(printScript);
    }
    return;
  }

  // File Download execution
  const now = new Date();
  const dateStr =
    now.getFullYear() +
    "-" +
    String(now.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(now.getDate()).padStart(2, "0");

  const fileExtension = downloadFormat === "word" ? "doc" : "html";
  const mimeType = downloadFormat === "word" ? "application/msword" : "text/html";
  const filename = `${docTitle.replace(/[\\/:*?"<>|]/g, "")}_${userName}_${dateStr}.${fileExtension}`;

  const element = document.createElement("a");
  const dataContent = downloadFormat === "word" ? ('\ufeff' + documentContent) : documentContent;
  const file = new Blob([dataContent], { type: mimeType });
  element.href = URL.createObjectURL(file);
  element.download = filename;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
